import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petitionComment/pageContext';

export function PetitionCommentErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for PetitionComment page (error: ${error})`);
}
